exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/page-header.js-WebpackMultiOutput";